import { Dialog } from 'primeng/dialog';

import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

declare var Stimulsoft: any;

@Component({
  selector: 'app-form-documents',
  templateUrl: './form-documents.component.html',
  styleUrls: ['./form-documents.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormDocumentsComponent implements OnInit {
  @Input() displayPreview: boolean = false;
  @Input() displayObj: any;
  @Input() displayMrt: string | null = null;
  @Output() closeEvent: EventEmitter<boolean> = new EventEmitter();
  viewer: any;
  displayNow = false;
  private isViewerInitialized = false;

  constructor() { }

  async ngOnInit() {
    await this.initViewer();
  }

  private async initViewer() {
    return new Promise<void>((resolve) => {

      if (this.isViewerInitialized) return resolve();

      Stimulsoft.Base.StiLicense.key =
        '6vJhGtLLLz2GNviWmUTrhSqnOItdDwjBylQzQcAOiHnj13QtIpBb3bzF4edVzsJoTgIhdVecmS9nvTBEnTDe2GLLF7' +
        'YHiVO2D/ZFVQNlOG67iOEX8t4DON6YPAqJeF9ugKvRpSXEn9KUj562MBRCdzrs1s91foEfXKY1i/7/t7eZwqcz+rG/' +
        'Kiovq0q8TVtsPrRfX11eExHPmG+Dxpv9Y8ydhbDAjkugIlk9JegpZWPle7+OOZhlU30THjWVLBCzJhco9/ypZeKTgm' +
        'OwBN1SyGYzGp8K0arJEZhbxlC9El1VbzkW20CeYUx0ZAyOZ+93un1bs5/r/cKQVkyOBlyKaD2AnwiYvNtcOCuZCMSy' +
        '3vkGdbcHIUwoFHhVcVsj0T1R3Qx5nqcJTsrhUk++HPT2b8n522imgkdepCaYCxyP5RGpk9TGzBTHGCgd8p9LfXdvO7' +
        'O83JeVKqix56dXEvC24JVoBlwtz40IpNv0H++InlUIWaJZfAWOnN7BMosoGbmWJfHWWf19dpZ/JfScbjQ9ZIgfNS/V' +
        '5lAuNTkfqUdx3UKlHxJKPQlBAHcTIq6qufAtXDLXj+Fy3+tl0OAVuZW3sagqxKdtlnZcXzh0r2o6VcNjA8nnWSr14O' +
        'QAAoV7hQwATYh924w0PDonsT2sIdCGkTzm5q+NTFOAc2fF6ZQjMZo+EOuuxqKWy+lfcla+mR71';

      let options = new Stimulsoft.Viewer.StiViewerOptions();
      // options.appearance.scrollbarsMode = true;
      // options.appearance.fullScreenMode = true;

      options.appearance.scrollbarsMode = false;
      options.appearance.fullScreenMode = false;

      options.appearance.interfaceType = Stimulsoft.Viewer.StiInterfaceType.Mouse;
      options.appearance.pageBorderColor = Stimulsoft.System.Drawing.Color.navy;
      options.toolbar.borderColor = Stimulsoft.System.Drawing.Color.navy;
      options.toolbar.showPrintButton = true;

      options.toolbar.showViewModeButton = true;
      options.toolbar.printDestination = Stimulsoft.Viewer.StiPrintDestination.Direct;
      options.toolbar.zoom = 50;
      this.viewer = new Stimulsoft.Viewer.StiViewer(options, 'StiViewer', false);
      this.isViewerInitialized = true;
      return resolve();
    });
  }

  hidePreview() {
    this.displayPreview = false;
    this.displayObj = null;
    this.displayMrt = null;
    this.viewer.visible = false;
    this.viewer = null;
    this.closeEvent.emit(this.displayPreview);
  }

  selectPreview(data: any, pathMRT: string, d: Dialog) {
    if (data.length) {
      this.showMultiplePreview(data, pathMRT, d);
    } else {
      this.showOncePreview(data, pathMRT, d);
    }
  }

  showOncePreview(data: any, pathMRT: string, d: Dialog) {
    d.contentViewChild.nativeElement.style.height = 'calc(100vh - 46px)';

    // Готовим data set
    const dataSet = new Stimulsoft.System.Data.DataSet();
    dataSet.readJson(JSON.stringify(data));

    // Настройка report
    const report: any = new Stimulsoft.Report.StiReport();
    report.loadFile(pathMRT);
    report.regData('JSON', 'JSON', dataSet);

    this.viewer.report = report;
    this.viewer.renderHtml('page_inner');

    setTimeout(() => {
      d.contentViewChild.nativeElement.style.height = 'calc(100vh - 46px)';
      this.viewer.jsObject.postAction('ZoomPageWidth');
    }, 1000);
  }

  showMultiplePreview(data: any, pathMRT: string, d: Dialog) {
    d.contentViewChild.nativeElement.style.height = 'calc(100vh - 46px)';

    if (!Array.isArray(data)) data = [data];
    const commonReport: any = new Stimulsoft.Report.StiReport();
    commonReport.isRendered = true;

    const newUnit = Stimulsoft.Report.Units.StiUnit.getUnitFromReportUnit(commonReport.reportUnit);
    commonReport.renderedPages.clear();
    data.forEach((dataItem) => {
      // Готовим data set
      const dataSet = new Stimulsoft.System.Data.DataSet();
      dataSet.readJson(JSON.stringify(dataItem));

      // Настройка report
      const report: any = new Stimulsoft.Report.StiReport();
      report.loadFile(pathMRT);
      report.regData('JSON', 'JSON', dataSet);
      report.render();
      // report.pages.list.forEach((page: any, index: number) => {
      //   page.components.list.forEach((component: any) => {
      //     component.components.list.forEach((component: any) => {
      //       if (component instanceof Stimulsoft.Report.Components.StiImage) {
      //         console.log(`Страница ${index + 1}: изображение найдено`);
      //         console.log(`imageUrl: `, component.imageURL);
      //         console.log(`imageString: `, component.imageString);
      //       }
      //     });
      //   });
      // });

      report.renderedPages.list.forEach((page) => {
        // Если это делаем, то теряются картинки
        // page.report = commonReport;
        page.newGuid();
        const oldUnit = Stimulsoft.Report.Units.StiUnit.getUnitFromReportUnit(report.reportUnit);
        if (commonReport.reportUnit != report.reportUnit) {
          page.convert(oldUnit, newUnit);
        }
        commonReport.renderedPages.add(page);
      });
    });

    this.viewer.report = commonReport;
    this.viewer.renderHtml('page_inner');

    setTimeout(() => {
      d.contentViewChild.nativeElement.style.height = 'calc(100vh - 46px)';
      this.viewer.jsObject.postAction('ZoomPageWidth');
    }, 1000);
  }
}
